module.exports = __webpack_public_path__ + "img/four.1457bbe9.png";